import styled, { css } from 'styled-components'
import { maxWidth, noTouch } from '@/assets/styles/mixins.css.js'
import vars from '@/assets/styles/vars'
import Social from './StyledSocial'
import Footer from './StyledFooter'

const desktopSpacePx = 40
const mobileSpacePx = 20

const MobileNav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 10;
  visibility: hidden;
  opacity: 0;
  cursor: pointer;
  background: rgba(var(--color-bg-dark-rgb), 0.5);
  transition: visibility 0s 0.35s, opacity 0.35s ease;
  -ms-scroll-chaining: none;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  user-select: none;

  ${Footer} {
    max-width: 660px;
     opacity: 0;
    transform: translateX(-100%);
    transition: transform 0.4s ease-in, opacity 0.3s linear;

    ${maxWidth(vars.breakpoints.mTablet)`
      max-width: none;
    `}
  }

  ${maxWidth(vars.breakpoints.tablet)`
    ${props =>
      props.visible &&
      css`
        opacity: 1;
        visibility: visible;
        pointer-events: all;
        transition: none;
        transition: visibility 0s, opacity 0.35s ease;
        display:flex;
        flex-direction:column;

        ${MobileNav.Menu},
         ${Footer} {
          opacity: 1;
          transform: none;
          transition: transform 0.4s ease-out, opacity 0.3s linear;
        }


        ${Footer.Data} {
          padding: 41px 20px 19px;
        }

        ${Footer.Image} {
          margin-top: 13px;
        }

        ${Social} {
          --social-width: 32px;
          --social-height: 32px;
        }
      `}
    `}

    
`

MobileNav.Menu = styled.div`
  position: relative;
  height: 100%;
  min-width: 250px;
  width: 100%;
  max-width: 660px;
  margin-right: auto;
  padding-top: 61px;
  opacity: 0;
  overflow: hidden;
  cursor: default;
  box-shadow: 2px 0px 12px rgba(0, 0, 0, 0.08);
  transform: translateX(-100%);
  transition: transform 0.4s ease-in, opacity 0.3s linear;

  ${maxWidth(vars.breakpoints.mTablet)`
    max-width: none;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    padding-top: 58px;
  `}
`

MobileNav.MenuInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f8f8f8;
  pointer-events: all;
`

MobileNav.Level = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: ${props => (props.visible ? 1 : 0)};
  overflow: hidden;
  transform: ${props => (props.visible ? 'translateX(0)' : 'translateX(-100%)')};
  transition: ${props =>
    props.visible
      ? 'transform 0.4s ease-out, background 0.4s ease-in, opacity 0.2s ease-out'
      : 'transform 0.4s ease-in, background 0.4s ease-out, opacity 0.3s ease-in'};
`


MobileNav.LevelInner = styled.div`
  width: 100%;
  height: 100%;
  padding: 36px 20px;
  overflow-x: hidden;
  overflow-y: auto;
  -ms-scroll-chaining: none;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  user-select: none;

  ${noTouch()`
    scrollbar-color: var(--color-extra) #ffffff;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      background-color: #ffffff;
      width: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--color-extra);
    }
  `}
`

MobileNav.List = styled.ul``

MobileNav.Item = styled.li`
`

MobileNav.Link = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 0 15px;
  font-size: 18px;
  line-height: 1.5;
  text-align: left;
  color: #b69b64;
  text-transform:uppercase;

  ${props =>
    props.arrow &&
    css`
      font-size: 18px;
      line-height: 1.5;
      color: #b69b64;
      &::after {
        content: '';
        display: inline-block;
        width: 7px;
        height: 7px;
        background-image: url("data:image/svg+xml,%3Csvg width='7' height='7' viewBox='0 0 7 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.24266 2.87132L3.37134 5.74265L0.500013 2.87132' stroke='%23B69B64' /%3E%3C/svg%3E");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        transform-origin: 50% 50%;
        transition: transform 0.3s ease 0s;
        flex-shrink: 0;
      }
    `}

    ${props =>
      props.isVisible &&
      css`
        &::after {
          transform: scaleY(-1);
          transition: transform 0.3s ease 0s;
        }
      `}

`
MobileNav.LevelSub = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};

  ${MobileNav.LevelInner} {
    padding: 0 0 15px;
    height: auto;
  }
  ${MobileNav.Link} {
    padding: 0 0 10px;
    font-size: 16px;
    line-height: 1.2;
    color: #323232;
    text-transform:none;
    &::after {
      background-image: url("data:image/svg+xml,%3Csvg width='7' height='7' viewBox='0 0 7 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.24266 2.87132L3.37134 5.74265L0.500013 2.87132' stroke='%23323232' /%3E%3C/svg%3E");
    }
  }
`

MobileNav.ExtraList = styled.ul`
  margin-top: -9px;

  ${MobileNav.Item} {

    &:first-child {
      ${MobileNav.Link} {
        padding-top: 9px;
      }
    }

    &:last-child {
      ${MobileNav.Link} {
        padding-bottom: 24px;
      }
    }
  }

  ${MobileNav.Link} {
    padding: 9px 40px 9px 48px;
    color: var(--color-secondary);

    ${maxWidth(vars.breakpoints.mobile)`
      padding: 10px 20px 11px 28px;
    `}
  }
`

MobileNav.Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

MobileNav.Footer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 32px;
  flex-shrink: 0;
  width: calc(100% + ${desktopSpacePx}px);
  margin-left: -${desktopSpacePx}px;
  padding: 38px ${desktopSpacePx}px 56px;
  background: var(--color-bg-accent);

  ${maxWidth(vars.breakpoints.lMobile)`
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 20px;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    width: calc(100% + ${mobileSpacePx}px);
    margin-left: -${mobileSpacePx}px;
    padding: 24px ${mobileSpacePx}px 38px;
  `}
`

MobileNav.FooterBlock = styled.div``

MobileNav.FooterTitle = styled.h3`
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.02em;
`

MobileNav.FooterList = styled.ul``

MobileNav.FooterItem = styled.li`
  & > * {
    display: inline-block;
    padding: 9px 0 10px;
    font-size: 16px;
    line-height: 1.2;
  }
`

MobileNav.SocialList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 32px);
  grid-gap: 10px 12px;
  flex-grow: 1;
  justify-content: flex-end;
  padding-top: 3px;

  ${Social} {
    --social-bg-color: var(--color-light);
    --social-border-color: var(--color-light);
    --social-width: 32px;
    --social-height: 32px;

    ${maxWidth(vars.breakpoints.lMobile)`
      --social-width: 40px;
      --social-height: 40px;
    `}
  }

  ${maxWidth(vars.breakpoints.lMobile)`
    order: -1;
    grid-template-columns: repeat(auto-fit, 40px);
    justify-content: flex-start;
    padding-bottom: 10px;
  `}
`

MobileNav.Back = styled.button`
  position: relative;
  display: flex;
  width: calc(100% + ${desktopSpacePx}px);
  margin-left: -${desktopSpacePx}px;
  padding: 32px ${desktopSpacePx}px 8px;
  color: var(--color-decor-dark);
  font-size: 12px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  ${maxWidth(vars.breakpoints.mobile)`
    width: calc(100% + ${mobileSpacePx}px);
    margin-left: -${mobileSpacePx}px;
    padding-left: ${mobileSpacePx}px;
    padding-right: ${mobileSpacePx}px;
  `}
`

MobileNav.BackIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  margin-right: 8px;
  margin-top: 2px;
  color: var(--color-decor-dark);
`

export default MobileNav
